import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
  Input,
  Container,
  Row,
  Col,
  Form,
} from "reactstrap";
import ReactModal from "react-modal";
import axios from "axios";
import Header from "components/Headers/Header";
import VariablesPorContrato from "views/examples/VariablesPorContrato";
import Swal from "sweetalert2";
const ContratoVariablesTabla = (props) => {
  const [variables, setVariables] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saveResult, setSaveResult] = useState("");
  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };
  // Sincronizar %numco% con props.id

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  // Obtener las variables del contrato y reemplazar dinámicamente
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://contratosback-dev.azurewebsites.net/api/v1/ObtieneVariablesContratos/${props.tipo}`,
    })
      .then((Response) => {
        const apiData = Response.data.map((item) => {
          if (item.variable === "%numco%") {
            return { ...item, contenido: String(props.id) };
          }
          if (
            item.variable === "%NOMBRE_O_RAZON_SOCIAL_CONTRATISTA%" ||
            item.variable === "%NOMBRE_o_RAZON_SOCIAL_CONTRATISTA%"
          ) {
            return { ...item, contenido: props.nombreProveedor || "" };
          }
          return item;
        });

        setVariables(apiData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.tipo, props.id, props.nombreProveedor]); // Incluye props.nombreProveedor como dependencia

  // Guardar cambios
  const saveChanges = () => {
    setIsLoading(true);

    // Validación de NotificacionProveedor
    const notificacion = variables.find(
      (v) => v.variable === "NotificacionProveedor"
    );

    if (notificacion) {
      const email = (notificacion.contenido || "").trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        Swal.fire({
          icon: "warning",
          title: "Correo inválido",
          text: "El campo 'NotificacionProveedor' debe contener un correo electrónico válido, sin espacios ni saltos de línea.",
          willOpen: zIndexFix,
        });
        setIsLoading(false);
        return;
      }

      // Elimina espacios o saltos de línea antes de guardar
      notificacion.contenido = email;
    }

    // Filtrar las variables que no deben ser guardadas
    const updatedVariables = variables
      .filter(
        (variable) =>
          variable.variable !== "%firma_rep_legal%" &&
          variable.variable !== "%firma_contratist%"
      )
      .map((variable) => ({
        ...variable,
        contenido: String(
          variable.variable === "%numco%" ? props.id : variable.contenido || ""
        ),
      }));

    const promises = updatedVariables.map((variable) => {
      return axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://contratosback-dev.azurewebsites.net/api/v1/CreaContratosVariables",
        data: {
          idContrato: props.id,
          variable: variable.variable,
          contenidoVariable: variable.contenido,
        },
      });
    });

    Promise.all(promises)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "¡Guardado exitoso!",
          text: "Todas las variables se guardaron correctamente.",
          willOpen: zIndexFix,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error al guardar",
          text: "Hubo un error al guardar las variables. Intenta nuevamente.",
          willOpen: zIndexFix,
        });
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Manejar cambios en el contenido de una variable
  const handleVariableChange = (index, newContent) => {
    setVariables((prevVariables) =>
      prevVariables.map((variable, i) =>
        i === index ? { ...variable, contenido: String(newContent) } : variable
      )
    );
  };

  // Generar el contrato
  const postGenera = (e) => {
    e.preventDefault();

    // Mostrar carga mientras se genera
    Swal.fire({
      title: "Generando contrato...",
      text: "Por favor espera",
      allowOutsideClick: false,
      willOpen: zIndexFix,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://contratosback-dev.azurewebsites.net/api/v1/GeneraContrato/${props.id}`,
    })
      .then((Response) => {
        console.log(Response.data);
        Swal.fire({
          title: "¡Éxito!",
          text: "Contrato generado con éxito.",
          icon: "success",
          confirmButtonText: "Aceptar",
          willOpen: zIndexFix,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload("/");
          }
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al generar el contrato",
          icon: "error",
          willOpen: zIndexFix,
          confirmButtonText: "Cerrar",
        });
      });
  };
  return (
    <>
      <button
        variant="contained"
        className="btn btn-info"
        color="primary"
        onClick={handleOpenModalTest}
        title="Diligenciar Contrato"
        style={{ padding: "5px 5px", fontSize: "10px" }}
      >
        Diligenciar Contrato
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: { zIndex: 2000 },
        }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",

            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <button
                    className="btn btn-danger btn-lg"
                    color="primary"
                    onClick={postGenera}
                  >
                    GENERAR CONTRATO
                  </button>
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Contratos Variables</h3>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Variables del Contrato
                    </h6>
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">Variable</th>
                          <th scope="col">Contenido</th>
                        </tr>
                      </thead>
                      <tbody>
                        {variables.map((variable, index) => (
                          <tr key={index}>
                            <td>{variable.variable}</td>
                            <td>
                              <Input
                                className="form-control-alternative"
                                id="input-postal-code"
                                type="textarea"
                                value={variable.contenido || ""}
                                onChange={(e) =>
                                  handleVariableChange(index, e.target.value)
                                }
                                disabled={
                                  variable.variable.includes(
                                    "%firma_rep_legal%"
                                  ) ||
                                  variable.variable.includes(
                                    "%firma_contratist%"
                                  ) ||
                                  variable.variable.includes("%numco%") ||
                                  variable.variable.includes(
                                    "%NOMBRE_O_RAZON_SOCIAL_CONTRATISTA%"
                                  ) ||
                                  variable.variable.includes(
                                    "%NOMBRE_o_RAZON_SOCIAL_CONTRATISTA%"
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div style={{ textAlign: "right" }}>
                      <Button
                        color="primary"
                        onClick={saveChanges}
                        disabled={isLoading}
                      >
                        {isLoading ? "Cargando..." : "Guardar cambios"}
                      </Button>
                    </div>
                    {saveResult && <div>{saveResult}</div>}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <VariablesPorContrato idContrato={props.id} />
      </ReactModal>
    </>
  );
};

export default ContratoVariablesTabla;
